import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const Videosurveillance = () => {
  const sectorData = {
    title: "Vidéosurveillance",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Les fournisseurs de solutions de sécurité vidéo doivent équilibrer technologie, conformité RGPD et protection périmétrique. Prospecter efficacement implique de cibler les directions sécurité, IT, maintenance ou DSI, avec des argumentaires orientés usages, ROI et réduction de risques.",
    name: "Vidéosurveillance",
    titleContext: "du secteur de la vidéosurveillance",
    responseContext: "du secteur de la Vidéosurveillance",
    expertContext: "du secteur de la vidéosurveillance"
  };

  return <SectorPage sector={sectorData} />;
};

export default Videosurveillance; 